// Navbar Container
export const NavbarContainer = {
    backgroundColor:'white',
    height:'70px',
    padding:'20px',
    display:'flex',
    flexDirection:'row',
    justifyContent:'space-between',
    alignItems:'center',
    position:'sticky'
}

// Account Icon Costum
export const AccountIconCostum = {
    backgroundColor:'#F5ECEC',
    padding:'10px 13px',
    borderRadius:'50%',
    cursor:'pointer',
    transition:'0.3s',
}

// Prover Costum 
export const ProverCostum = {
    padding: '10px',
    color:'black',
    display:'flex',
    flexDirection:'column',
    gap:'10px',
    justifyContent:'center',
    alignItems:'center'
}